import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import SEO from "./SEO/SEO";


const Page = forwardRef(
  (
    {
      children,
      title = "",
      description,
      descrition = "",
      canonical,
      image,
      noindex = false,
      ...rest
    },
    ref
  ) => {
    const metaDescription = (description ?? descrition ?? "").trim();

    return (
      <div ref={ref} {...rest}>
        <SEO
          title={title}
          description={metaDescription || undefined}
          canonical={canonical}
          image={image}
          noindex={noindex}
        />
        {children}
      </div>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  descrition: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  noindex: PropTypes.bool,
};

export default Page;
